export default function RolesListController(
  $scope,
  $filter,
  $stateParams,
  $state,
  RoleService,
  gettextCatalog,
) {
  'ngInject';

  //Local Variables
  $scope.unavailable = 'Unavailable';
  $scope.searchText = '';
  $scope.previousSearchText = '';
  $scope.selectedName = '';
  $scope.roles = [];
  $scope.filteredUserRoles = [];
  $scope.userRolesByPage = [];
  $scope.itemsPerPage = 25;
  $scope.maxSize = 3;
  $scope.currentPage = 1;

  //Sorting
  $scope.predicate = 'name';
  $scope.reverse = false;

  //Sort filteredUserData
  $scope.orderRoles = function (predicate) {
    if (predicate === $scope.predicate) {
      $scope.reverse = !$scope.reverse;
    } else {
      $scope.reverse = false;
    }
    $scope.predicate = predicate;
    GTM_ListChanged('rolesOrderChanged');
  };

  //applyFilter searchs the roles[] for anything matching the search input.
  $scope.applyFilter = function () {
    if ($scope.previousSearchText === $scope.searchText) return;
    $scope.filteredUserRoles = $filter('filter')($scope.roles, $scope.searchText);
    $scope.previousSearchText = $scope.searchText;
    GTM_ListChanged('rolesFiltered');
  };

  $scope.createSuccessFlag = false;
  $scope.deleteSuccessFlag = false;
  $scope.errorFlag = false;
  $scope.errorText = '';
  $scope.loading = true;

  if ($stateParams.create) {
    $scope.createSuccessFlag = true;
  } else if ($stateParams.deleted) {
    $scope.deleteSuccessFlag = true;
  }

  $scope.resetFlags = function () {
    $scope.createSuccessFlag = false;
    $scope.deleteSuccessFlag = false;
  };

  //Tracks the selected row of the userRoles table
  $scope.roleSelected = function (name) {
    $scope.selectedName = name;
  };

  //Get all userRoles
  RoleService.getRoles({ assignable: true }).then(function (response) {
    $scope.roles = response.data;
    $scope.filteredUserRoles = $scope.roles.slice();
    $scope.loading = false;
    GTM_ListChanged('rolesLoaded');
  }, handleError);

  //general error handler.
  function handleError(error) {
    $scope.loading = false;
    let errorMsg = gettextCatalog.getString('An error occurred while retrieving role information');
    if (error.data || error.status) {
      if (error.data.message) {
        errorMsg =
          error.data.message +
          ' ' +
          (error.status.toString() + ' - ' + error.statusText.toString());
      } else {
        errorMsg += ': ' + (error.status.toString() + ' - ' + error.statusText.toString());
      }
    } else {
      errorMsg += gettextCatalog.getString('. Please try again later.');
    }

    $scope.onLoadErrorFlag = true;
    $scope.onLoadErrorText = errorMsg;
  }

  $scope.pageChanged = function () {
    GTM_ListChanged('rolesPageChanged');
  };

  function GTM_ListChanged(event) {
    window.dataLayer.push({
      event: event,
      data: {
        total: $scope.roles.length,
        totalFiltered: $scope.filteredUserRoles.length,
        orderBy: $scope.predicate,
        sortDirection: $scope.reverse ? 'descending' : 'ascending',
        pageNumber: $scope.currentPage,
      },
    });
  }
}
